<template>
  <div>
    <h2 class="content-block">Edit Registration</h2>
    <div class="content-block dx-card responsive-paddings">
      <form action="action" @submit.prevent="onUpdate">    
        <DxForm :form-data="formData">
          <template #avatar-template="{}">
            <div class="form-avatar" />
          </template>
          <DxGroupItem :col-count="4" css-class="first-group">
            <DxSimpleItem template="avatar-template" />
            <DxGroupItem :col-span="3">
              <DxSimpleItem data-field="FirstName" :editor-options="editorOptions">
                <DxRequiredRule />
              </DxSimpleItem>
              <DxSimpleItem data-field="LastName" :editor-options="editorOptions">
                <DxRequiredRule />
              </DxSimpleItem>
            </DxGroupItem>
          </DxGroupItem>
          <DxGroupItem :col-count="1" css-class="second-group">
            <DxGroupItem>
              <DxSimpleItem data-field="EmailAddress" :editor-options="editorOptions">
                <DxRequiredRule />
              </DxSimpleItem>
              <DxSimpleItem data-field="PhoneNumber" :editor-options="phoneOptions">
                <DxRequiredRule />
              </DxSimpleItem>
            </DxGroupItem>
          </DxGroupItem>
          <DxButtonItem :button-options="buttonOptions" horizontal-alignment="center" />
        </DxForm>
        </form>
    </div>
  </div>
  </template>
  <script>
  import {
    DxForm,
    DxSimpleItem,
    DxButtonItem,
    DxGroupItem,
    DxLabel,
    DxRequiredRule,
    DxCompareRule,
    DxRangeRule,
    DxStringLengthRule,
    DxPatternRule,
    DxEmailRule,
    DxAsyncRule
  } from 'devextreme-vue/form'
  import { DxTextArea } from 'devextreme-vue/text-area'

  import { mapActions, mapState } from 'vuex'
  import { UPDATE_PROFILE } from "@/store/_actiontypes"
  export default {
    components: {
      DxForm,
      DxTextArea,
      DxGroupItem,
      DxSimpleItem,
      DxButtonItem,
      DxLabel,
      DxRequiredRule,
      DxCompareRule,
      DxRangeRule,
      DxStringLengthRule,
      DxPatternRule,
      DxEmailRule,
      DxAsyncRule
    },
    data() {
      return {
        formData: {},
        editorOptions: {
          disabled: false
        },
        buttonOptions: {
            text: 'Update',
            type: 'normal',
            useSubmitBehavior: true,
        },
        passwordOptions: { visible: true,  mode: 'password' },
        passwordVisibility: false,
        checkBoxOptions: {
          text: 'Change Password ?',
          onValueChanged: (e) => {
            this.passwordVisibility = e.component.option('value');
          },
        },
        phoneOptions: { mask: '+242 000 000 000', readOnly: false },
        notesOptions: { height: 140, disabled: true },
      }
    },   
    
    computed: {
      ...mapState({
        profile: state => state?.user?.user?.data?.admistration_Details
      }),
    },
  
    created() {
      let profileData = {
        Id_: this.profile?.id,
        UserName: this.profile?.pr_Phone,
        FirstName: this.profile?.pr_First_Name,
        LastName: this.profile?.pr_Last_Name,
        DateRegistered: this.profile?.created_At,
        PhoneNumber: this.profile?.pr_Phone,
        EmailAddress: this.profile?.pr_Email_Address,
        Status: this.profile?.is_Relevant,
        ChangePassword: false
      }
      this.formData = profileData
    },

    methods: {
      ...mapActions("application", [ UPDATE_PROFILE] ),
      onUpdate() {
        this.UPDATE_PROFILE(this.formData).then(res => {
            this.$toast.success("User updated successfully.")
          })
          .catch(error => {
            this.$toast.error(error)  
          })
       }
    },
  }
  </script>
  <style>
  .first-group,
  .second-group {
    padding: 20px;
  }
  
  .second-group {
    background-color: rgba(191, 191, 191, 0.15);
  }
  
  .form-avatar {
    height: 128px;
    width: 128px;
    margin-right: 10px;
    border: 1px solid #d2d3d5;
    border-radius: 50%;
    background-image: url("../assets/default.jpg");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
  </style>